import React from "react";
import Popup from "../User/popup";
import { useTranslation } from "react-i18next";
function ConfirmExitModal({ open, onConfirm, onCancel }) {
  const { t: trans } = useTranslation(["new"]);
  return (
    // <div className="modal-backdrop">
    //   <div className="modal-content">
    //     <h2>هل أنت متأكد أنك تريد مغادرة الصفحة؟</h2>
    //     <button onClick={onConfirm}>نعم، غادر</button>
    //     <button onClick={onCancel}>لا، ابق هنا</button>
    //   </div>
    // </div>



    <Popup show={open}>
      <div className="w-full  flex flex-column justify-center items-center" >
        <div className="cart-finalized" >
          <div className=" flex flex-column justify-center items-center ">

            <div className=" flex flex-col gap-3">
              <img src="/assets/Loding_new.svg" width={120} height={120} alt="Loding" />

              {/* <span className="text-20 font-bold  text-primary mx-2 unselectable ">{trans("new:شكرًا لطلبك...!")}</span> */}
            </div>
            {
              <>
                <div className="flex mt-10 flex-wrap justify-center mx-20">
                  <span className="text-24 text-gray  mx-2">{trans("new:Are_you_sure_leave_page")}</span>
                </div>
                <div className="flex mt-10 flex-wrap justify-center mx-20">
                  <span className="text-24 text-gray  mx-2">{trans("new:Your_changes_may_not_be_saved")}</span>
                </div>
              </>

            }


            <div className="flex nice-flex-center  nice-align-item-center nice-flex-space-between w-100  gap-5 justify-items-auto 
                            py-10 px-20   ">

              <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7">

                <div className={"btn nice-flex-row  py-5 px-5 text-white text-24  bg-danger"}
                  onClick={async () => {

                    onConfirm()
                  }}>{trans("new:Yes_leave")}
        
                </div>

              </div>
              <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">

                <div className={"btn nice-flex-row  py-5 px-5 text-white text-24 bg-primary "}
                  onClick={async () => {

                    onCancel()
                  }}




                >{trans("new:No_stay_here")}
              
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Popup>
  );
}

export default ConfirmExitModal;
